const websocketActionTypes = {
    SET_WEBSOCKET_SUBSCRIBE_LIST: 'SET_WEBSOCKET_SUBSCRIBE_LIST'
}

export default websocketActionTypes